import { handleActions, combineActions } from 'redux-actions'

import { TabeebColors } from '@tabeeb/enums'
import { expandPanel } from '@tabeeb/modules/sessionTabs/actions'
import {
  onEnableDrawing,
  onDisableDrawing,
  onSetDrawingType,
  onSetDrawingWidth,
  onSetDrawingPreset,
  onSetDrawingColor,
  onSetDrawingScale,
  onSetTransparency,
  onDisposeDrawing,
  onHideAnnotations,
  onEnableSelection,
  onDisableSelection,
} from '../../actions/drawing'
import * as playerToolbarActions from '../../actions'

const defaultValue = {
  isDrawing: false,
  isSelecting: false,
  color: TabeebColors.Red,
  type: 0,
  width: 3,
  transparency: 1,
  preset: null,
  scale: 1,
}

export default handleActions(
  {
    [onEnableDrawing](state) {
      return { ...state, isDrawing: true, isSelecting: false }
    },
    [onDisableDrawing](state) {
      return { ...state, isDrawing: false }
    },
    [onEnableSelection](state) {
      return { ...state, isSelecting: true, isDrawing: false }
    },
    [onDisableSelection](state) {
      return { ...state, isSelecting: false }
    },
    [onSetDrawingColor](state, action) {
      return { ...state, color: action.payload }
    },
    [onSetDrawingType](state, action) {
      return { ...state, type: action.payload }
    },
    [onSetDrawingPreset](state, action) {
      return { ...state, preset: action.payload }
    },
    [onSetDrawingScale](state, action) {
      return { ...state, scale: action.payload }
    },
    [onSetDrawingWidth](state, action) {
      return { ...state, width: action.payload }
    },
    [onSetTransparency](state, action) {
      return { ...state, transparency: action.payload }
    },
    [combineActions(onDisposeDrawing, expandPanel, onHideAnnotations)](state, action) {
      return defaultValue
    },
    [playerToolbarActions.resetState](state, action) {
      return defaultValue
    },
  },
  defaultValue
)
